const apiConfig = {
    "baseUrl": "http://localhost:3300",
    "gateWayUrl": "https://login-api.tiburaglobal.com:8082",
    "dashboard": "http://localhost:8082/",
    "webUrl": "https://synergy-uat.axodesk.com/login",
    "appName": "Identti Front End",
    "apiKey": "apiKey",
    "appId": "b0dc92bf-3710-4e11-a87d-4d72585cd281",
    "secrect": "secrect",
}
export default apiConfig;


